/**
 * Mentions légales de facture, par régime.
 *
 * Elles s'impriment sous les totaux. Une galerie peut les remplacer dans son
 * profil fiscal (`tax_profile.mentions`) ; celles-ci sont les valeurs par
 * défaut, écrites dans la voix du produit : phrases courtes, pas de jargon.
 */
import { pourcentageDuRegime, REGIMES_TVA } from './regimes.js';
/** Le taux de chaque régime, en pourcentage, pour l'impression. */
export const POURCENTAGES = Object.fromEntries(REGIMES_TVA.map((regime) => [regime, pourcentageDuRegime(regime)]));
/** La mention propre à chaque régime. */
export const MENTIONS_REGIME = {
    reduit_5_5: {
        fr: 'Taux réduit de 5,5 % : œuvre d’art importée ou cédée par son auteur.',
        en: 'Reduced rate of 5.5%: work of art imported or sold by its creator.',
    },
    marge: {
        fr: 'Régime particulier — Biens d’occasion, objets d’art, de collection ou d’antiquité. TVA sur la marge, non récupérable par l’acheteur.',
        en: 'Margin scheme — Second-hand goods, works of art, collectors’ items and antiques. VAT on the margin, not recoverable by the buyer.',
    },
    exonere: {
        fr: 'Exonération de TVA. Livraison intracommunautaire ou exportation.',
        en: 'Exempt from VAT. Intra-Community supply or export.',
    },
};
/** La mention à porter dès qu'un droit de suite est dû. */
export const MENTION_DROIT_DE_SUITE = {
    fr: 'Droit de suite dû à l’auteur ou à ses ayants droit, reversé à l’organisme de gestion collective.',
    en: 'Resale right due to the artist or their heirs, paid to the collecting society.',
};
//# sourceMappingURL=mentions.js.map